export type Role = 'DRIVER' | 'DISPATCHER' | 'MANAGER' | 'ADMIN' | 'SUPERADMIN'

export const ROLE_LEVELS: Record<string, number> = {
  DRIVER: 1,
  DISPATCHER: 2,
  MANAGER: 3,
  ADMIN: 4,
  SUPERADMIN: 5,
}

export function hasMinimumRole(userRole: string, requiredRole: string): boolean {
  return (ROLE_LEVELS[userRole] ?? 0) >= (ROLE_LEVELS[requiredRole] ?? 999)
}

// Display labels only — the underlying role enum values are unchanged.
// Single source of truth (was duplicated in LeftNavRail, NavDrawer, Profile).
export const ROLE_LABELS: Record<string, string> = {
  SUPERADMIN: 'Platform Administrator',
  ADMIN: 'Distribution Administrator',
  MANAGER: 'Operations Manager',
  DISPATCHER: 'Dispatcher',
  DRIVER: 'Driver',
}

/** i18n key for a role label (messages/en.json → "role.*"). */
export function roleMessageId(role: string): string {
  return `role.${role.toLowerCase()}`
}

export const ROLE_COLORS: Record<string, string> = {
  SUPERADMIN: 'bg-amber-100 text-amber-800',
  ADMIN: 'bg-red-100 text-red-800',
  MANAGER: 'bg-purple-100 text-purple-800',
  DISPATCHER: 'bg-blue-100 text-blue-800',
  DRIVER: 'bg-green-100 text-green-800',
}

/**
 * Landing route per role (BLUEPRINT §2 / audit §9). ADMIN lands on the setup
 * checklist until onboarding progress ≥ 80 %.
 */
export function landingPathForRole(role: string | null | undefined, opts: { onboardingProgress?: number | null } = {}): string {
  switch (role) {
    case 'SUPERADMIN': return '/platform'
    case 'ADMIN': {
      const p = opts.onboardingProgress
      return p != null && p >= 80 ? '/today' : '/settings/setup'
    }
    case 'MANAGER': return '/performance'
    case 'DISPATCHER': return '/today'
    case 'DRIVER': return '/mobile-app'
    default: return '/today'
  }
}
